module.exports = __webpack_public_path__ + "static/img/bg3.31daf5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg3.png
// module id = vegf
// module chunks = 3